export const tableConfig = {
    table: {
        height: 400,
        size: 'mini',
        selection: true,
        columns: [
            {
                label: '上传方式',
                prop: 'fileSourceName',
                sort: true,
                width: '90px'
            },
            {
                label: '上传人',
                prop: 'updateUserName',
                sort: true,
                width: '110px'
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                sort: true,
                width: '245px'
            },
            {
                label: '运输单号',
                prop: 'taskNo',
                sort: true,
                width: '190px'
            },
            {
                label: '预览',
                prop: 'view',
                type: 'button',
                width: '80px'
            },
            {
                label: '是否围栏内上传',
                prop: 'isUploadInFence',
                type: 'select',
                optionsKey: [
                    { label: '是', value: 'Y' },
                    { label: '否', value: 'N' }
                ],
                sort: true,
                width: '130px'
            },
            {
                label: '上传回单距离(km)',
                prop: 'uploadDistance',
                sort: true,
                width: '140px'
            },
            {
                label: '上传时间',
                prop: 'updateTime',
                sort: true,
                width: '130px'
            },
            {
                label: '文件名称',
                prop: 'name',
                sort: true,
                width: '150px'
            }
        ]
    },
    OBJECT_CONST: {
        PIC_TYPES: ['jpg', 'png', 'gif', 'jpeg', 'tif', 'bmp', 'webp']
    }
};
